module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/ZoomPlus-cd9462eab97ec490a57d3b2d3b697f62.svg";